<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="tabclick">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first" disabled="disabled">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.mac" @keyup.enter.native="clicksearch" placeholder="请输入MAC地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.chaoqi" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择体验期超期" value="1"></el-option>
              <el-option label="已超期" value="2"></el-option>
              <el-option label="未超期" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.registertype" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择注册方式" value="0"></el-option>
              <el-option label="未知注册方式" value="1"></el-option>
              <el-option label="APP注册" value="2"></el-option>
              <el-option label="云端注册" value="3"></el-option>
              <el-option label="睿世力云管理APP注册" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择设备类型" value=""></el-option>
              <el-option
                v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
              <el-option label="未绑定设备" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
              <el-option
                v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.diopterstate" placeholder="请选择" class="select" style="width: 200px;">
              <el-option label="请选择屈光状态" value="0"></el-option>
              <el-option label="正视" value="6"></el-option>
              <el-option label="远视" value="2"></el-option>
              <el-option label="近视" value="1"></el-option>
              <el-option label="散光" value="7"></el-option>
              <el-option label="老花" value="3"></el-option>
              <el-option label="屈光参差" value="8"></el-option>
              <el-option label="远视性弱视" value="9"></el-option>
              <el-option label="散光性弱视" value="10"></el-option>
              <el-option label="近视性弱视" value="11"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="注册时间(开始)" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="注册时间(结束)" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickexcel(1)" v-if="SubRule_Customer_Excel">导出Excel</el-button>
            <el-button type="primary" @click="clickexcel(23040401)" v-if="SubRule_Customer_Excel">导出每周后台新用户注册信息</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Id" label="ID" min-width="4%" v-if="SubRule_Customer_Forcedelete"></el-table-column>
          <el-table-column prop="Loginname" label="登录名" min-width="4%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="4%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="4%"></el-table-column>
          <el-table-column prop="Sexs" label="性别" min-width="4%"></el-table-column>
          <el-table-column prop="Phone" label="电话号" min-width="5%" v-if="SubRule_Customer_Modify"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构" min-width="5%"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号" min-width="5%"></el-table-column>
          <el-table-column label="初始裸眼视力" align="center">
            <el-table-column prop="Nakedrighteyedegreef" label="OD" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedlefteyedegreef" label="OS" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedbinoculusdegreef" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column label="最新裸眼视力" align="center">
            <el-table-column prop="Nakedrighteyedegreel" label="OD" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedlefteyedegreel" label="OS" min-width="4%"></el-table-column>
            <el-table-column prop="Nakedbinoculusdegreel" label="OU" min-width="4%"></el-table-column>
          </el-table-column>
          <el-table-column prop="Usestates" label="是否暂停" min-width="5%"></el-table-column>
          <el-table-column prop="Delaytime" label="到期日/剩余分钟" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="注册时间" min-width="7%"></el-table-column>
          <el-table-column prop="Ipaddress" label="IP地址" min-width="7%"></el-table-column>
          <el-table-column label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goRegisteredOptometry(scope.row)">注册视光查看</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goViewDetails(scope.row)">用户资料</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Modify" @click="goCustomerChange(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_GetEyeInfo" @click="goVisionTrendChart(scope.row)">视力复查趋势图</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_GetEyeInfo" @click="goViewVisionReview(scope.row)">添加/查看视力复查</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Pause" @click="suspend(scope.row)">强制暂停</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Forcedelete" @click="removeUser(scope.row)">删除用户(慎重,无法恢复)</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Ip" @click="goHistoricalIPAddress(scope.row)">历史IP地址</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_ChangeUserLogin" @click="goChangeUserLogin(scope.row)">修改登录名</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_ExcelSingleDiopter" @click="clickExcelSingleDiopter(scope.row)">导出视光聚合数据</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_ExcelSingleDiopter" @click="clickExcelLowHighData(scope.row)">导出低高峰数据</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Erp7ShiGuang" @click="goSubVueeleven(scope.row)">1基本信息</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Erp7ShiGuang" @click="goSubVuethirteen(scope.row)">2验光检查档案</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Erp7ShiGuang" @click="goSubVuetwelve(scope.row)">3调节功能数据分析</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Erp7ShiGuang" @click="goSubVuefourteen(scope.row)">4眼健康评估曲线图</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_Customer_Erp7ShiGuang" @click="goSubVuefifteen(scope.row)">5复查前后对比图</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加客户 start -->
      <el-tab-pane v-loading.fullscreen.lock="fullscreenloading" label="添加客户" name="second" v-if="SubRule_Customer_Add">
        <el-form :model="addCustomer" ref="addCustomerRef" label-width="68px">
          <el-form-item label="用户姓名" class="addAdminForm">
            <el-input v-model="addCustomer.name" placeholder="请输入用户姓名"></el-input>
          </el-form-item>
          <el-form-item label="用户年龄" class="addAdminForm">
            <el-input v-model="addCustomer.age" placeholder="请输入用户年龄"></el-input>
          </el-form-item>
          <el-form-item label="性别" class="addAdminForm">
            <el-radio v-model="addCustomer.sex" label="1">男</el-radio>
            <el-radio v-model="addCustomer.sex" label="2">女</el-radio>
          </el-form-item>
          <el-form-item label="详细地址" class="addAdminForm">
            <el-input v-model="addCustomer.address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="绑定设备" class="addAdminForm">
            <el-input v-model="addCustomer.cardnumber" placeholder="请输入保修卡号"></el-input>
            <el-button type="success" plain @click="apicheckcardnumber">校验</el-button>
            <li>设备机构：{{addCustomer.jigouname}}</li>
            <li>设备类型：{{addCustomer.bomsnName}}</li>
            <li>销售类型：{{addCustomer.saletypeName}}</li>
          </el-form-item>
          <el-form-item label="手机号码" class="addAdminForm">
            <el-input v-model="addCustomer.phone" placeholder="请输入手机号码"></el-input>
            <el-button v-if="!Nocheckphone" type="success" plain @click="apigetpincode">获取</el-button>
          </el-form-item>
          <el-form-item v-if="!Nocheckphone" label="验证码" class="addAdminForm">
            <el-input v-model="addCustomer.pincode" placeholder="请输入验证码"></el-input>
          </el-form-item>
          <el-form-item label="账号" class="addAdminForm">
            <el-input v-model="addCustomer.customerloginname" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" class="addAdminForm">
            <el-input v-model="addCustomer.customerpassword" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>

          <!-- 视光信息 start -->
          <div class="title">视光信息</div>
          <div class="optometry">
            <el-form-item label="屈光状态" class="select2">
              <el-select v-model="addCustomer.diopterstate" placeholder="请选择" style="width: 100%">
                <el-option label="请选择" value="0"></el-option>
                <el-option label="正视" value="6"></el-option>
                <el-option label="远视" value="2"></el-option>
                <el-option label="近视" value="1"></el-option>
                <el-option label="散光" value="7"></el-option>
                <el-option label="老花" value="3"></el-option>
                <el-option label="屈光参差" value="8"></el-option>
                <el-option label="远视性弱视" value="9"></el-option>
                <el-option label="散光性弱视" value="10"></el-option>
                <el-option label="近视性弱视" value="11"></el-option>
              </el-select>
            </el-form-item>
            <ul>
              <li>1. 0~+0.50D选择正视；</li>
              <li>2. 远视、远视+散光且矫正视力正常选择远视注册；</li>
              <li>3. 近视、近视+散光且矫正视力正常选择近视注册；</li>
              <li>4. 单纯散光选择散光注册；</li>
              <li>5. 40岁以上，近用需要下加光的选择老花注册；</li>
              <li>6. 球柱中和后，两眼度数相差1.00D以上选择屈光参差注册；</li>
              <li>公式：新球=1/2柱+球</li>
              <li>7. 矫正视力低于正常年龄下限的，请选择弱视注册。具体如下：</li>
              <li>（1）远视+散光引起的弱视：远视性弱视</li>
              <li>（2）近视+散光引起的弱视：近视性弱视</li>
              <li>（3）单纯散光引起的弱视：散光性弱视</li>
              <li>对应矫正视力下限如下：</li>
              <li>3岁：0.4；4岁：0.5；5岁：0.6,6岁：0.8；7岁以上：1.0及以上（年龄为周岁）</li>
            </ul>
          </div>
          <!-- 视光信息 end -->

          <!-- 屈光度 -->
          <el-table :data="diopterData" border stripe class="mt20">
            <el-table-column label="屈光度" align="center">
              <el-table-column label="OD(右眼)" align="center">
                <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.righteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.rightcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.rightaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="OS(左眼)" align="center">
                <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.lefteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.leftcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.leftaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- ADD和调节幅度 -->
          <el-table :data="addData" border stripe class="mt20">
            <el-table-column label="ADD和调节幅度" align="center">
              <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.addtype" placeholder="请选择" style="width: 100%">
                    <el-option label="0.00D" value="0"></el-option>
                    <el-option label="0.50D" value="1"></el-option>
                    <el-option label="0.75D" value="2"></el-option>
                    <el-option label="1.00D" value="3"></el-option>
                    <el-option label="1.25D" value="4"></el-option>
                    <el-option label="1.50D" value="5"></el-option>
                    <el-option label="1.75D" value="6"></el-option>
                    <el-option label="2.00D" value="7"></el-option>
                    <el-option label="2.25D" value="8"></el-option>
                    <el-option label="2.50D" value="9"></el-option>
                    <el-option label="2.75D" value="10"></el-option>
                    <el-option label="3.00D" value="11"></el-option>
                    <el-option label="3.25D" value="12"></el-option>
                    <el-option label="3.50D" value="13"></el-option>
                    <el-option label="3.75D" value="14"></el-option>
                    <el-option label="4.00D" value="15"></el-option>
                    <el-option label="4.25D" value="16"></el-option>
                    <el-option label="4.50D" value="17"></el-option>
                    <el-option label="4.75D" value="18"></el-option>
                    <el-option label="5.00D" value="19"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="adjust" label="调节幅度(范围:0.00D~+22.00D)">
                <template slot-scope="scope">
                  <el-input v-model="addCustomer.amp"></el-input>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 裸眼和矫正视力 -->
          <el-table :data="nakedEye" border stripe class="mt20">
            <el-table-column label="5m裸眼视力(5分记录法)" align="center">
              <el-table-column prop="odRight" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="最佳矫正视力(5分记录法)" align="center">
              <el-table-column prop="odRight1" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft1" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble1" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 瞳距，内透镜规格 -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="瞳距(单位:mm)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.interpupillary"></el-input>
              </template>
            </el-table-column>
              <el-table-column label="内置透镜规格(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.neizhitjggright" placeholder="请选择">
                    <el-option
                      v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="内置透镜规格(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.neizhitjggleft" placeholder="请选择">
                    <el-option
                      v-for="item in neizhitjgglist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
          </el-table>

          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加客户 end -->

      <el-tab-pane label="注册视光查看" name="three" disabled="disabled">
        <CustomerManagementRegisterOpt ref="SubVuethree" v-on:triggerFunc="BackToFirst"></CustomerManagementRegisterOpt>
      </el-tab-pane>

      <el-tab-pane label="用户资料" name="four" disabled="disabled">
        <CustomerManagementViewDetails ref="SubVuefour" v-on:triggerFunc="BackToFirst"></CustomerManagementViewDetails>
      </el-tab-pane>

      <el-tab-pane label="修改" name="five" disabled="disabled">
        <CustomerManagementChange ref="SubVuefive" v-on:triggerFunc="BackToFirst"></CustomerManagementChange>
      </el-tab-pane>

      <el-tab-pane label="视力复查趋势图" name="six" disabled="disabled">
        <CustomerManagementVisionChart ref="SubVuesix" v-on:triggerFunc="BackToFirst"></CustomerManagementVisionChart>
      </el-tab-pane>

      <el-tab-pane label="添加/查看视力复查" name="seven" disabled="disabled">
        <CustomerManagementVisionReview ref="SubVueseven" v-on:triggerFunc="BackToFirst"></CustomerManagementVisionReview>
      </el-tab-pane>

      <el-tab-pane label="强制暂停" name="eight" disabled="disabled">
        <CustomerManagementSuspend ref="SubVueeight" v-on:triggerFunc="BackToFirst"></CustomerManagementSuspend>
      </el-tab-pane>

      <el-tab-pane label="历史IP地址" name="nine" disabled="disabled">
        <CustomerManagementIPAddress ref="SubVuenine" v-on:triggerFunc="BackToFirst"></CustomerManagementIPAddress>
      </el-tab-pane>

      <el-tab-pane label="修改登录名" name="ten" disabled="disabled">
        <CustomerManagementChangeUserLogin ref="SubVueten" v-on:triggerFunc="BackToFirst"></CustomerManagementChangeUserLogin>
      </el-tab-pane>

      <el-tab-pane label="基本信息" name="eleven" disabled="disabled">
        <CustomerBasicInfo ref="SubVueeleven" v-on:triggerFunc="BackToFirst"></CustomerBasicInfo>
      </el-tab-pane>

      <el-tab-pane label="验光检查档案" name="thirteen" disabled="disabled">
        <CustomerYanGuangJianCha ref="SubVuethirteen" v-on:triggerFunc="BackToFirst"></CustomerYanGuangJianCha>
      </el-tab-pane>

      <el-tab-pane label="调节功能数据分析" name="twelve" disabled="disabled">
        <CustomerTiaoJieGongNeng ref="SubVuetwelve" v-on:triggerFunc="BackToFirst"></CustomerTiaoJieGongNeng>
      </el-tab-pane>

      <el-tab-pane label="眼健康评估曲线图" name="fourteen" disabled="disabled">
        <CustomerYanJianKangQuXian ref="SubVuefourteen" v-on:triggerFunc="BackToFirst"></CustomerYanJianKangQuXian>
      </el-tab-pane>

      <el-tab-pane label="复查前后对比图" name="fifteen" disabled="disabled">
        <CustomerQianHouFuChaDuiBiTu ref="SubVuefifteen" v-on:triggerFunc="BackToFirst"></CustomerQianHouFuChaDuiBiTu>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import CustomerManagementRegisterOpt from '@/componentsSubVue/CustomerManagementRegisterOpt.vue'
import CustomerManagementViewDetails from '@/componentsSubVue/CustomerManagementViewDetails.vue'
import CustomerManagementChange from '@/componentsSubVue/CustomerManagementChange.vue'
import CustomerManagementVisionChart from '@/componentsSubVue/CustomerManagementVisionChart.vue'
import CustomerManagementVisionReview from '@/componentsSubVue/CustomerManagementVisionReview.vue'
import CustomerManagementSuspend from '@/componentsSubVue/CustomerManagementSuspend.vue'
import CustomerManagementIPAddress from '@/componentsSubVue/CustomerManagementIPAddress.vue'
import CustomerManagementChangeUserLogin from '@/componentsSubVue/CustomerManagementChangeUserLogin.vue'
import CustomerBasicInfo from '@/componentsSubVue/CustomerBasicInfo.vue'
import CustomerTiaoJieGongNeng from '@/componentsSubVue/CustomerTiaoJieGongNeng.vue'
import CustomerYanGuangJianCha from '@/componentsSubVue/CustomerYanGuangJianCha.vue'
import CustomerYanJianKangQuXian from '@/componentsSubVue/CustomerYanJianKangQuXian.vue'
import CustomerQianHouFuChaDuiBiTu from '@/componentsSubVue/CustomerQianHouFuChaDuiBiTu.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    CustomerManagementRegisterOpt,
    CustomerManagementViewDetails,
    CustomerManagementChange,
    CustomerManagementVisionChart,
    CustomerManagementVisionReview,
    CustomerManagementSuspend,
    CustomerManagementIPAddress,
    CustomerManagementChangeUserLogin,
    CustomerBasicInfo,
    CustomerTiaoJieGongNeng,
    CustomerYanGuangJianCha,
    CustomerYanJianKangQuXian,
    CustomerQianHouFuChaDuiBiTu
  },
  name: 'MyCustomerManagement',
  data () {
    return {
      loading: false,
      fullscreenloading: false,
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        loginname: '',
        name: '',
        phone: '',
        mac: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: '',
        chaoqi: '1',
        registertype: '0',
        bomsn: '',
        saletype: '0',
        diopterstate: '0',
        begintime: '',
        endtime: ''
      },
      // 添加客户
      addCustomer: {
        name: '',
        age: '',
        sex: '1',
        address: '',
        cardnumber: '',
        phone: '',
        pincode: '',
        customerloginname: '',
        customerpassword: '',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        addtype: '0',
        amp: '0.00',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        neizhitjggright: '8',
        neizhitjggleft: '8',
        jigouname: '',
        bomsnName: '',
        saletypeName: ''
      },
      //
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      tongJuData: [
        { tongju: '请输入', leftEye: '请选择', rightEye: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ],
      neizhitjgglist: [
        { value: '8', label: '无' },
        { value: '1', label: 'A' },
        { value: '2', label: 'B' },
        { value: '3', label: 'C' },
        { value: '4', label: 'D' },
        { value: '5', label: 'E' },
        { value: '6', label: 'F' },
        { value: '7', label: '其他' }
      ],
      SubRule_Customer_Add: false,
      SubRule_Customer_Excel: false,
      SubRule_Customer_ExcelSingleDiopter: false,
      SubRule_Customer_Modify: false,
      SubRule_Customer_GetEyeInfo: false,
      SubRule_Customer_Pause: false,
      SubRule_Customer_Forcedelete: false,
      SubRule_Customer_Ip: false,
      SubRule_Customer_ChangeUserLogin: false,
      SubRule_Customer_Erp7ShiGuang: false,
      Nocheckphone: false,
      timestamplocal: 0
    }
  },
  mounted () {
    this.apigetcustomernum()
    this.apigetcustomerlist()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Excel', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Excel = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_ExcelSingleDiopter', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_ExcelSingleDiopter = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Modify', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Modify = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_GetEyeInfo', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_GetEyeInfo = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Pause', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Pause = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Forcedelete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Forcedelete = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Ip', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Ip = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_ChangeUserLogin', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_ChangeUserLogin = true
      }
    })
    Vue.prototype.FunCheckSubRule('Nocheckphone', function (response) {
      if (response.data.Code === 200) {
        that.Nocheckphone = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Erp7ShiGuang', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Erp7ShiGuang = true
      }
    })
    // setTimeout(function () {
    //   that.addCustomer.customerloginname = ''
    //   that.addCustomer.customerpassword = ''
    // }, 1000)
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    tabclick (e) {
      this.addCustomer.name = ''
      this.addCustomer.age = ''
      this.addCustomer.sex = '1'
      this.addCustomer.address = ''
      this.addCustomer.cardnumber = ''
      this.addCustomer.phone = ''
      this.addCustomer.pincode = ''
      this.addCustomer.customerloginname = ''
      this.addCustomer.customerpassword = ''
      this.addCustomer.diopterstate = '0'
      this.addCustomer.righteyedegree = '0.00'
      this.addCustomer.rightcolumnmirror = '0.00'
      this.addCustomer.rightaxial = '0'
      this.addCustomer.lefteyedegree = '0.00'
      this.addCustomer.leftcolumnmirror = '0.00'
      this.addCustomer.leftaxial = '0'
      this.addCustomer.addtype = '0'
      this.addCustomer.amp = '0.00'
      this.addCustomer.nakedrighteyedegree = '0'
      this.addCustomer.nakedlefteyedegree = '0'
      this.addCustomer.nakedbinoculusdegree = '0'
      this.addCustomer.correctrighteyedegree = '0'
      this.addCustomer.correctlefteyedegree = '0'
      this.addCustomer.correctbinoculusdegree = '0'
      this.addCustomer.interpupillary = ''
      this.addCustomer.neizhitjggright = '8'
      this.addCustomer.neizhitjggleft = '8'
      this.addCustomer.jigouname = ''
      this.addCustomer.bomsnName = ''
      this.addCustomer.saletypeName = ''
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetcustomerlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetcustomernum()
      this.apigetcustomerlist()
    },
    clickexcel (filetype) {
      if(filetype == 23040401){
        if(this.keywords.begintime.length < 1 || this.keywords.endtime.length < 1){
          Vue.prototype.FunAlertMsg("请设置时间")
          return
        }
      }
      this.apigetcustomerexcel(filetype)
    },
    clickExcelSingleDiopter (row) {
      this.apiExcelSingleDiopter(row.Id,103)
    },
    clickExcelLowHighData (row) {
      this.apiExcelSingleDiopter(row.Id,24011501)
    },
    clickAdd () {
      this.apiaddcustomer()
    },
    // 跳转到客户修改界面
    goCustomerChange (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 查看详情
    goViewDetails (row) {
      this.activeName = 'four'
      this.$refs.SubVuefour.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 强制暂停
    suspend (row) {
      this.activeName = 'eight'
      this.$refs.SubVueeight.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 修改登录名
    goChangeUserLogin (row) {
      this.activeName = 'ten'
      this.$refs.SubVueten.LoadData(row)
    },
    // 历史IP地址
    goHistoricalIPAddress (row) {
      this.activeName = 'nine'
      this.$refs.SubVuenine.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 注册视光查看
    goRegisteredOptometry (row) {
      if (row.Isinputdushu == '1') {
        Vue.prototype.FunAlertMsg('该用户还未注册视光数据，请联系用户完善注册信息')
        return
      }
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 查看视力复查
    goViewVisionReview (row) {
      this.activeName = 'seven'
      this.$refs.SubVueseven.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 基本信息
    goSubVueeleven (row) {
      this.activeName = 'eleven'
      this.$refs.SubVueeleven.LoadData(row.Id)
    },
    // 调节功能数据分析
    goSubVuetwelve (row) {
      this.activeName = 'twelve'
      this.$refs.SubVuetwelve.LoadData(row.Id)
    },
    // 验光检查档案
    goSubVuethirteen (row) {
      this.activeName = 'thirteen'
      this.$refs.SubVuethirteen.LoadData(row.Id)
    },
    // 眼健康评估曲线图
    goSubVuefourteen (row) {
      this.activeName = 'fourteen'
      this.$refs.SubVuefourteen.LoadData(row.Id)
    },
    // 前后复查对比图
    goSubVuefifteen(row) {
      this.activeName = 'fifteen'
      this.$refs.SubVuefifteen.LoadData(row.Id)
    },
    // 视力复查趋势图
    goVisionTrendChart (row) {
      this.activeName = 'six'
      this.$refs.SubVuesix.LoadData({ name: '', params: { userid: row.Id } })
    },
    // 删除用户确认
    removeUser (row) {
      this.$confirm('是否删除此用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiforcedeletecustomer(row.Id)
      })
    },
    apigetcustomerlist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        chaoqi: that.keywords.chaoqi,
        registertype: that.keywords.registertype,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = []
            response.data.List.filter((item1, i1) => {
              var Sexs = '男'
              if (item1.Sex == 2) Sexs = '女'
              var Usestates = '否'
              if (item1.Usestate == 2) Usestates = '是'
              var Ipaddress = item1.Ip + '(' + item1.Ipprovince + item1.Ipcity + ')'
              that.dataList.push({ Id: item1.Id, Loginname: item1.Loginname, Name: item1.Name, Age: item1.Age, Sex: item1.Sex, Sexs: Sexs, Phone: item1.Phone, Jigouid: item1.Jigouid, Jigouname: item1.Jigouname, Mac: item1.Mac, Cardnumber: item1.Cardnumber, Nakedrighteyedegreef: item1.Nakedrighteyedegreef, Nakedlefteyedegreef: item1.Nakedlefteyedegreef, Nakedbinoculusdegreef: item1.Nakedbinoculusdegreef, Nakedrighteyedegreel: item1.Nakedrighteyedegreel, Nakedlefteyedegreel: item1.Nakedlefteyedegreel, Nakedbinoculusdegreel: item1.Nakedbinoculusdegreel, Usestate: item1.Usestate, Usestates: Usestates, Delaytime: item1.Delaytime, Createtime: item1.Createtime, Ip: item1.Ip, Ipprovince: item1.Ipprovince, Ipcity: item1.Ipcity, Ipaddress: Ipaddress, Provinceid: item1.Provinceid, Cityid: item1.Cityid, Districtid: item1.Districtid, Address: item1.Address, Speedstate: item1.Speedstate, Isinputdushu: item1.Isinputdushu })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apigetcustomernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        chaoqi: that.keywords.chaoqi,
        registertype: that.keywords.registertype,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetcustomerexcel: function (filetype) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        phone: that.keywords.phone,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid,
        chaoqi: that.keywords.chaoqi,
        registertype: that.keywords.registertype,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype,
        diopterstate: that.keywords.diopterstate,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        filetype: filetype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerexcel, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelSingleDiopter: function (glassuserid,exceltype) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: glassuserid,
        exceltype: exceltype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelSingleDiopter, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckcardnumber: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cardnumber: that.addCustomer.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCardnumber, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.addCustomer.cardnumber = response.data.Cardnumber
            that.addCustomer.jigouname = response.data.Jigouname
            that.addCustomer.bomsnName = response.data.BomsnName
            that.addCustomer.saletypeName = response.data.SaletypeName
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetpincode: function () {
      var that = this

      var timestampnow = Date.parse(new Date()) / 1000
      var dif = timestampnow - that.timestamplocal
      if (dif <= 60) {
        var diff = 60 - dif
        Vue.prototype.$alert('操作过于频繁.请等待' + diff + '秒后再获取短信验证码。', '提示', {
          confirmButtonText: '确定',
          callback: action => {}
        })
        return
      }

      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        phone: that.addCustomer.phone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getpincode, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.timestamplocal = timestampnow
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddcustomer: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.addCustomer.name,
        age: that.addCustomer.age,
        sex: that.addCustomer.sex,
        address: that.addCustomer.address,
        cardnumber: that.addCustomer.cardnumber,
        phone: that.addCustomer.phone,
        pincode: that.addCustomer.pincode,
        loginname: that.addCustomer.customerloginname,
        password: that.addCustomer.customerpassword,
        diopterstate: that.addCustomer.diopterstate,
        righteyedegree: that.addCustomer.righteyedegree,
        rightcolumnmirror: that.addCustomer.rightcolumnmirror,
        rightaxial: that.addCustomer.rightaxial,
        lefteyedegree: that.addCustomer.lefteyedegree,
        leftcolumnmirror: that.addCustomer.leftcolumnmirror,
        leftaxial: that.addCustomer.leftaxial,
        addtype: that.addCustomer.addtype,
        amp: that.addCustomer.amp,
        nakedrighteyedegree: that.addCustomer.nakedrighteyedegree,
        nakedlefteyedegree: that.addCustomer.nakedlefteyedegree,
        nakedbinoculusdegree: that.addCustomer.nakedbinoculusdegree,
        correctrighteyedegree: that.addCustomer.correctrighteyedegree,
        correctlefteyedegree: that.addCustomer.correctlefteyedegree,
        correctbinoculusdegree: that.addCustomer.correctbinoculusdegree,
        interpupillary: that.addCustomer.interpupillary,
        neizhitjggright: that.addCustomer.neizhitjggright,
        neizhitjggleft: that.addCustomer.neizhitjggleft
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addcustomer, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetcustomernum()
            that.apigetcustomerlist()
          })
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    apiforcedeletecustomer: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Forcedeletecustomer, Qs.stringify(data))
        .then(function (response) {
          that.apigetcustomernum()
          that.apigetcustomerlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
